import { lazy } from 'react';
import type { RouteObject } from 'react-router-dom';
import { Guard } from '../../components/layout/Guard';

const List = lazy(() => import('./ReceivablesPage'));
const Detail = lazy(() => import('./ReceivableDetailPage'));

const routes: RouteObject[] = [
  { path: '/receivables', element: <Guard any={['receivable.read']}><List /></Guard> },
  { path: '/receivables/:id', element: <Guard any={['receivable.read']}><Detail /></Guard> },
];
export default routes;
